import { Tabs, TabsList, TabsTrigger, TabsContent } from "../../../components/ui/tabs";
import { OverviewTab } from "./overview-tab";
import { ProductivityTab } from "./productivity-tab";
import { ErrorsTab } from "./errors-tab";

const DashboardRoute = () => {
    return (
        <div className="mx-auto py-6 lg:py-10 px-4 sm:px-6 lg:px-8 xl:px-32">
            <div className="mb-6">
                <h1 className="text-xl font-semibold text-foreground">Fleet Dashboard</h1>
                <p className="text-sm text-muted-foreground mt-1">
                    Monitor your fleet's health, productivity, and errors at a glance.
                </p>
            </div>

            <Tabs defaultValue="overview">
                <TabsList className="mb-6">
                    <TabsTrigger value="overview">Overview</TabsTrigger>
                    <TabsTrigger value="productivity">Productivity</TabsTrigger>
                    <TabsTrigger value="errors">Errors</TabsTrigger>
                </TabsList>

                <TabsContent value="overview">
                    <OverviewTab />
                </TabsContent>

                <TabsContent value="productivity">
                    <ProductivityTab />
                </TabsContent>

                <TabsContent value="errors">
                    <ErrorsTab />
                </TabsContent>
            </Tabs>
        </div>
    );
};

export { DashboardRoute };
